var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastroFormulario.imovel
    ? _c(
        "div",
        [
          _vm.tipoCadastro && _vm.tipoCadastro !== "ONEROSO"
            ? _c(
                "el-row",
                { staticClass: "labelDiv", attrs: { gutter: 30 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required", name: "Imóvel/Possui Car" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Possui CAR ?",
                                  required: true,
                                  name: "Imovel"
                                }
                              }),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { label: true },
                                  model: {
                                    value: _vm.radioPossuiCar,
                                    callback: function($$v) {
                                      _vm.radioPossuiCar = $$v
                                    },
                                    expression: "radioPossuiCar"
                                  }
                                },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { label: false },
                                  model: {
                                    value: _vm.radioPossuiCar,
                                    callback: function($$v) {
                                      _vm.radioPossuiCar = $$v
                                    },
                                    expression: "radioPossuiCar"
                                  }
                                },
                                [_vm._v("Não")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1584918044
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.radioPossuiCar ||
          (_vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO")
            ? _c(
                "el-row",
                { staticClass: "labelDiv", attrs: { gutter: 30 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required|reciboCar",
                      name: "Imóvel/Número do Recibo"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Número do Recibo do Car:",
                                  required: true,
                                  name: "Imovel"
                                }
                              }),
                              _c("the-mask", {
                                staticClass: "input el-input__inner",
                                class: { erro: errors.length },
                                attrs: {
                                  name: "Número do Recibo do Car",
                                  mask: [
                                    "AA-NNNNNNN-FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF.FFFF"
                                  ],
                                  tokens: _vm.tokens,
                                  masked: true
                                },
                                model: {
                                  value:
                                    _vm.cadastroFormulario.imovel
                                      .numeroReciboCar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.cadastroFormulario.imovel,
                                      "numeroReciboCar",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "cadastroFormulario.imovel.numeroReciboCar"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2195949139
                    )
                  })
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "el-row",
                    { staticClass: "labelDivRow", attrs: { guter: 30 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "col", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Imóvel/Nome do imóvel"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Nome do imóvel:",
                                          required: true,
                                          name: "Imovel"
                                        }
                                      }),
                                      _c("el-input", {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: {
                                          type: "text",
                                          maxlength: "300"
                                        },
                                        model: {
                                          value:
                                            _vm.cadastroFormulario.imovel.nome,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.cadastroFormulario.imovel,
                                              "nome",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "cadastroFormulario.imovel.nome"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2825358920
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "col", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Imóvel/Município"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Município:",
                                          required: true,
                                          name: "Imovel"
                                        }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "input select",
                                          class: { erro: errors.length },
                                          attrs: {
                                            name: "Município",
                                            "no-match-text":
                                              "Nenhum município encontrado",
                                            placeholder: "Selecione",
                                            filterable: "filterable",
                                            "value-key": "id"
                                          },
                                          model: {
                                            value:
                                              _vm.cadastroFormulario.imovel
                                                .municipio,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cadastroFormulario.imovel,
                                                "municipio",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cadastroFormulario.imovel.municipio"
                                          }
                                        },
                                        _vm._l(_vm.municipios, function(item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.nome,
                                              value: item
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2129043998
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "col", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required|areaReservaLegal",
                              name: "Imóvel/Área"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Área:",
                                          required: true,
                                          name: "Imovel"
                                        }
                                      }),
                                      _c(
                                        "el-input",
                                        {
                                          directives: [
                                            {
                                              name: "mask-decimal",
                                              rawName: "v-mask-decimal.br",
                                              value: 4,
                                              expression: "4",
                                              modifiers: { br: true }
                                            }
                                          ],
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: {
                                            type: "text",
                                            maxlength: 19
                                          },
                                          model: {
                                            value: _vm.imovelArea,
                                            callback: function($$v) {
                                              _vm.imovelArea = $$v
                                            },
                                            expression: "imovelArea"
                                          }
                                        },
                                        [
                                          _c("template", { slot: "append" }, [
                                            _vm._v("hectare(s)")
                                          ])
                                        ],
                                        2
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              76589811
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "labelDivRow", attrs: { guter: 30 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "col", attrs: { span: 24 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Imóvel/Vias de acesso/localização"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Vias de acesso/localização:",
                                          required: true,
                                          name: "Imovel"
                                        }
                                      }),
                                      _c("el-input", {
                                        class: { erro: errors.length },
                                        attrs: {
                                          type: "textarea",
                                          autosize: { minRows: 4, maxRows: 8 }
                                        },
                                        model: {
                                          value:
                                            _vm.cadastroFormulario.imovel
                                              .descricaoAcesso,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.cadastroFormulario.imovel,
                                              "descricaoAcesso",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "cadastroFormulario.imovel.descricaoAcesso"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2430439091
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
          _c(
            "el-row",
            { staticClass: "labelDivRow", attrs: { guter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "col", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Imóvel/Há ocupantes anteriores"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Há ocupantes anteriores?",
                                  required: true,
                                  name: "Imovel"
                                }
                              }),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { label: true },
                                  model: {
                                    value: _vm.radioOcupantesAnteriores,
                                    callback: function($$v) {
                                      _vm.radioOcupantesAnteriores = $$v
                                    },
                                    expression: "radioOcupantesAnteriores"
                                  }
                                },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { label: false },
                                  model: {
                                    value: _vm.radioOcupantesAnteriores,
                                    callback: function($$v) {
                                      _vm.radioOcupantesAnteriores = $$v
                                    },
                                    expression: "radioOcupantesAnteriores"
                                  }
                                },
                                [_vm._v("Não")]
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2556541438
                    )
                  })
                ],
                1
              ),
              _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
                ? _c(
                    "el-col",
                    { staticClass: "col", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Imóvel/Possui outros imóveis rurais no Pará"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label:
                                        "Possui outros imóveis rurais no Pará? ?",
                                      required: true,
                                      name: "Imovel"
                                    }
                                  }),
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { label: true },
                                      model: {
                                        value: _vm.radioPossuiImovel,
                                        callback: function($$v) {
                                          _vm.radioPossuiImovel = $$v
                                        },
                                        expression: "radioPossuiImovel"
                                      }
                                    },
                                    [_vm._v("Sim")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { label: false },
                                      model: {
                                        value: _vm.radioPossuiImovel,
                                        callback: function($$v) {
                                          _vm.radioPossuiImovel = $$v
                                        },
                                        expression: "radioPossuiImovel"
                                      }
                                    },
                                    [_vm._v("Não")]
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2635054226
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { staticClass: "col", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Imóvel/Tempo de ocupação"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Tempo de ocupação",
                                  required: true,
                                  name: "Imovel"
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "tempo-ocupacao input" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "select-size" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          class: { erro: errors.length },
                                          attrs: {
                                            filterable: "filterable",
                                            placeholder: "0",
                                            size: "small",
                                            name: "Tempo Ocupação"
                                          },
                                          model: {
                                            value:
                                              _vm.cadastroFormulario.imovel
                                                .tempoOcupacao,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.cadastroFormulario.imovel,
                                                "tempoOcupacao",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cadastroFormulario.imovel.tempoOcupacao"
                                          }
                                        },
                                        _vm._l(
                                          _vm.tempoOcupacaoOptions,
                                          function(tempoOcupacao) {
                                            return _c("el-option", {
                                              key: tempoOcupacao.value,
                                              attrs: {
                                                label: tempoOcupacao.label,
                                                value: tempoOcupacao.value
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.cadastroFormulario.imovel
                                          .tempoOcupacao === 1
                                          ? "ano"
                                          : "anos"
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      312783264
                    )
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "labelDivRow", attrs: { guter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "col", attrs: { span: 12 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: "Imóvel/Há conflitos no imóvel"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Há conflitos no imóvel?",
                                  required: true,
                                  name: "Imovel"
                                }
                              }),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { label: true },
                                  model: {
                                    value: _vm.radioHaConflitos,
                                    callback: function($$v) {
                                      _vm.radioHaConflitos = $$v
                                    },
                                    expression: "radioHaConflitos"
                                  }
                                },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "input",
                                  class: { erro: errors.length },
                                  attrs: { label: false },
                                  model: {
                                    value: _vm.radioHaConflitos,
                                    callback: function($$v) {
                                      _vm.radioHaConflitos = $$v
                                    },
                                    expression: "radioHaConflitos"
                                  }
                                },
                                [_vm._v("Não")]
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1640846612
                    )
                  })
                ],
                1
              ),
              _vm.radioHaConflitos
                ? _c(
                    "el-col",
                    { staticClass: "col", attrs: { span: 12 } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: "Número do Processo Judicial",
                          required: false,
                          name: "Imovel"
                        }
                      }),
                      _c("el-input", {
                        model: {
                          value:
                            _vm.cadastroFormulario.imovel
                              .numeroProcessoJudicial,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.cadastroFormulario.imovel,
                              "numeroProcessoJudicial",
                              $$v
                            )
                          },
                          expression:
                            "cadastroFormulario.imovel.numeroProcessoJudicial"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
            ? _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { gutter: 30 }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _vm.tiposDocumentos.length
                        ? _c("app-documentos-retificacao", {
                            attrs: {
                              maxSize: 20,
                              "valid-extensions": _vm.extensoes,
                              documentos: _vm.documentosImovel,
                              tiposDocumentos: _vm.tiposDocumentos,
                              tiposDocumentosObrigatorios:
                                _vm.tiposDocumentosObrigatorios,
                              observer: this.$refs.validation,
                              isDocumentoImagex: true,
                              titulo: "Documentação",
                              aba: "Imóvel",
                              idUploadDocumento:
                                "appUploadDocumentosInteressado"
                            },
                            on: {
                              addedDoc: _vm.handleDocs,
                              removedDoc: _vm.removerDocs
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
            ? _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { gutter: 30 }
                },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required|termo", name: "Imóvel/termo" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "el-row",
                                { class: { erroTermo: errors.length } },
                                [
                                  _c("el-checkbox", {
                                    attrs: { required: true },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.imovel.termo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.imovel,
                                          "termo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.imovel.termo"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v("  " + _vm._s(_vm.mensagemFormatada))
                                  ])
                                ],
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1923981039
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40a04e36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a04e36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/Imovel.vue
// module id = null
// module chunks = 